define(["require", "exports"], function (require, exports) {
    "use strict";
    exports.__esModule = true;
    exports._test = (function ($) {
        $.fn.actionBar = function (option) {
            var _this = this;
            if (option === 'hide') {
                this.parent().toggleClass('hide', true);
            }
            else if (option === 'show') {
                this.parent().toggleClass('hide', false);
            }
            else if (option === 'refresh') {
                this.trigger('actionBar:refresh');
            }
            else if (isActionBarOptions(option)) {
                var className = option.className, onclick_1 = option.onclick, onrefresh_1 = option.onrefresh, clickTarget = option.clickTarget;
                (clickTarget || this.find('button')).click(onclick_1);
                this.wrap("<div class=\"bottom-action-bar " + (className || '') + "\"></div>");
                if (onrefresh_1) {
                    onrefresh_1(this);
                    this.on('actionBar:refresh', function () {
                        onrefresh_1(_this);
                    });
                }
            }
            else {
                this.find('button').click(option);
                this.wrap('<div class="bottom-action-bar"></div>');
            }
            return this;
        };
    })($);
    function isActionBarOptions(obj) {
        return typeof obj === 'object';
    }
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/jquery-plugins/actionBar.js
// module id = 21
// module chunks = 0